import getConfig from 'next/config';

import { isServer } from 'lib/common/constants';
import {
  getOneTimePass,
  logonWithPass,
  getActiveOrders,
  getRestaurantInfo,
} from 'lib/store/liveOrders/actions';

export default ({ dispatch }) => (next) => {
  if (isServer) {
    return next;
  }

  const { publicRuntimeConfig: config } = getConfig();
  const configInterval = config.webRomTokenRefreshMinutes ?? 0;
  const minutes = Math.max(configInterval, 1);
  const tokenRefreshInterval = minutes * 60 * 1000;
  let pendingRefreshID;
  const authenticateLiveOrders = async (branchId) => {
    const { payload } = await dispatch(getOneTimePass(branchId));
    await dispatch(logonWithPass(payload.pass));
  };

  return async (action) => {
    const result = next(action);
    switch (action.type) {
      case 'LOGON_WITH_PASS_SUCCESS': {
        const { restaurant_id: restaurantId } = action.payload;
        clearTimeout(pendingRefreshID);

        pendingRefreshID = setTimeout(async () => {
          authenticateLiveOrders(restaurantId);
        }, tokenRefreshInterval);

        break;
      }
      case 'AUTHENTICATE_LIVE_ORDERS': {
        const { branchId } = action.extra;
        await authenticateLiveOrders(branchId);
        dispatch(getActiveOrders(branchId));
        dispatch(getRestaurantInfo(branchId));
        break;
      }
      default:
        break;
    }

    return result;
  };
};
